import { render, staticRenderFns } from "./GridItemColorsConfig.vue?vue&type=template&id=4f59d034&"
import script from "./GridItemColorsConfig.vue?vue&type=script&lang=js&"
export * from "./GridItemColorsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports